import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  addTaskBtn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.8125rem",
    borderRadius: "6px",
    padding: "4px 12px",
    marginRight: "10px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
      transform: "translateY(-1px)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },
}));

export default useStyles;
